import { Alert } from "@/components/alert/alert";
import { Button } from "@/components/ui/buttons/button";
import { useSPAContext, Intent } from "@/providers/spa-provider";
import { useUser } from "@/providers/user-provider";
import { RouteNames } from "@/types/route-names";
import { useState } from "react";

export const HomeBottomNav = () => {
  const { setCurrentRoute, setIntent, setSelectedPokemons } = useSPAContext();
  const { state: userState } = useUser();

  const handleRankClick = () => {
    if (userState.status === "awaiting_alpha_approval") {
      Alert("You don't have alpha permission, request access from an admin.");
      return;
    }
    setIntent(undefined);
    setCurrentRoute(RouteNames.LEADERBOARD);
  };

  return (
    <nav className="w-full z-50 px-2 py-2 shadow-2xl relative">
      <div className="absolute bottom-0 left-0 w-full h-16 bg-pk-gray-1 z-[1]"></div>
      <div className="grid grid-cols-5 items-center gap-1 z-[2] relative">
        <BottomNavButton
          icon="poke"
          text="Pokes"
          onClick={() => {
            setIntent(undefined);
            setCurrentRoute(RouteNames.INVENTORY_POKE);
          }}
        />

        <BottomNavButton
          icon="flag"
          text="Teams"
          onClick={() => {
            setIntent(undefined);
            setCurrentRoute(RouteNames.TEAM_LIST);
          }}
        />

        <BottomNavButton
          icon="egg"
          text="Breed"
          onClick={() => {
            setIntent(Intent.SELECTING_POKEMONS_TO_BREED);
            setSelectedPokemons([]);
            setCurrentRoute(RouteNames.INVENTORY_POKE);
          }}
        />

        <BottomNavButton
          icon="chest"
          text="Items"
          onClick={() => {
            setIntent(undefined);
            setCurrentRoute(RouteNames.INVENTORY_ITEMS);
          }}
        />

        <BottomNavButton icon="medal" text="Rank" onClick={handleRankClick} />
      </div>
    </nav>
  );
};

type BottomNavButtonProps = {
  icon: string;
  text: string;
  onClick: () => void;
};

const BottomNavButton = ({ icon, text, onClick }: BottomNavButtonProps) => {
  return (
    <Button variant="default" onClick={onClick}>
      <div className="flex flex-col items-center justify-center gap-1">
        <img
          src={`/assets/icons/${icon}.png`}
          width={24}
          height={24}
          className="
          w-8 h-8 object-contain
          drop-shadow-[0_2px_0_rgba(0,0,0,1)]
          group-hover:drop-shadow-[0_2px_0_rgba(0,0,0,1)]
        "
        />

        <span
          className="
          text-xs xs:text-sm
          w-full flex items-center justify-center
          font-black tracking-wide
          text-pk-gray-4
          drop-shadow-[0_2px_0_rgba(0,0,0,1)]
        "
        >
          {text}
        </span>
      </div>
    </Button>
  );
};
